export default __webpack_public_path__ + "static/lightSandPoppy-37045e7d172a2a7fd8290dd4f5a1416c.webp";